module.exports = __webpack_public_path__ + "img/header-background-in.a4cd1ee0.png";